<div class="policies-requests">
    <div class="policies align-items-right">
        <h3>{{ _translateService.Keys.POLICIES_TITLE | translate }}</h3>
        <div *ngFor="let quote of quotes; let i = index">
            <p class="item" [ngClass]="activeQuote(i) ? 'active' : ''" (click)="selectQuote(i)">
                {{ getQuoteName(quote) }}
            </p>
        </div>
    </div>
    <div class="request-content align-items-right">
        <h3>{{ _translateService.Keys.POLICIES_REQUESTS | translate }}</h3>
        <div>
            <p class="item m-0">
                <a [href]="'mailto:' + email + '?subject=' + getGeneralLiabilityEmailSubject() +'&cc='+supportEmail">
                    {{ _translateService.Keys.POLICIES_GENERAL_LIABILITY_QUOTE | translate }}
                </a>
            </p>
        </div>
        <div>
            <p class="item m-0">
                <a href="{{claimsReportingUrl}}" target="_blank">
                    {{ _translateService.Keys.POLICIES_CLAIMS_REPORTING | translate }}
                </a>
            </p>
        </div>
    </div>
</div>
